/** IST calendar helpers (mirror backend istDate — avoid en-CA on Windows). */

const IST = 'Asia/Kolkata';

export function getISTParts(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: IST,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);
  const map = {};
  for (const p of parts) {
    if (p.type !== 'literal') map[p.type] = p.value;
  }
  const year = Number(map.year);
  const month = Number(map.month);
  const day = Number(map.day);
  const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  return { year, month, day, dateStr };
}

export function getISTDateString(date = new Date()) {
  return getISTParts(date).dateStr;
}

export function addDaysToYmd(ymd, deltaDays) {
  const [y, m, d] = ymd.split('-').map(Number);
  const utc = new Date(Date.UTC(y, m - 1, d + deltaDays));
  return `${utc.getUTCFullYear()}-${String(utc.getUTCMonth() + 1).padStart(2, '0')}-${String(utc.getUTCDate()).padStart(2, '0')}`;
}

export function getISTMonthStartString(date = new Date()) {
  const { year, month } = getISTParts(date);
  return `${year}-${String(month).padStart(2, '0')}-01`;
}

export function daysInMonth(year, month1to12) {
  return new Date(Date.UTC(year, month1to12, 0)).getUTCDate();
}

export function monthEnd(year, month1to12) {
  return `${year}-${String(month1to12).padStart(2, '0')}-${String(daysInMonth(year, month1to12)).padStart(2, '0')}`;
}

export function mondayPad(year, month0) {
  const dow = new Date(Date.UTC(year, month0, 1)).getUTCDay();
  return (dow + 6) % 7;
}

export function periodBounds(period) {
  const today = getISTDateString();
  if (period === '7d') {
    return { startDate: addDaysToYmd(today, -6), endDate: today };
  }
  return { startDate: getISTMonthStartString(), endDate: today };
}
